export const smallScreenCssRules = {
  ".classic-nav-module__navItemsContainer": {
    "flex-wrap": "nowrap !important",
  },
  '.classic-nav-module__navItem[href="/#/insights/answers"]': {
    display: "none !important",
  },
  '.classic-nav-module__navItem[href="/#/home"]': {
    display: "none !important",
  },
  ".home-library-module__actionbarContainer": {
    "flex-wrap": "wrap !important",
  },
};
